import styled from 'styled-components';

const NotifyMeStyled = styled.div`
  width: 102%;
  .notify-me,
  .notified {
    font-size: 14px !important;
    font-weight: 700 !important;
  }

  .notified .left {
    margin-left: -9px;
    opacity: 40%;
  }

  .notified-text {
    opacity: 40%;
  }
`;

export default NotifyMeStyled;
